import { takeEvery, put } from "redux-saga/effects";
import { request } from "../../../api/Service";
import { getErrorMessage } from "../../../components/utils/errorHandler";
import { toast } from "react-toastify";
import { store } from "../../store";

export default function* watcherGetProductsSalesPriceSaga() {
  yield takeEvery("LOAD_PRODUCT_SALES_PRICE", workerSaga);
}

function* workerSaga(action) {
  try {
    yield put({ type: "DISPLAY_LOADER", payload: payload });
    var payload = {};
    let formatUrl = "get-all-product-sale-price";
    yield request("get", action.payload, formatUrl).then((response) => {
      payload = response;
    });
    yield put({ type: "PRODUCT_SALESPRICE_LIST", payload: payload });

    yield put({ type: "DISPLAY_LOADER", payload: payload });

    formatUrl =
      "api/Admin/get-product-dropdown?id=" +
      store.getState().persistReducer.companyId;
    yield request("get", {}, formatUrl).then((response) => {
      payload = response;
    });
    yield put({ type: "PRODUCT_DROPDOWN_LIST", payload: payload });
  } catch (e) {
    console.log(e);
    console.log("product-sales-price-saga", e);
    console.log("product-sales-price-saga", e.response);
    yield put({ type: "LOADING_BUTTON_SPINNER" });
    const errorMessage = getErrorMessage(e.response);
    toast.error(errorMessage);
    yield put({ type: "API_ERRORED", payload: e });
    yield put({ type: "DISPLAY_LOADER", payload: payload });
  }
}
